const config = {
  basename: "",
};
export default config;
